module.exports = __webpack_public_path__ + "img/1080_16.44468682.jpg";